import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectHouseId, selectRegionId } from 'shared/selectors/houseInfo';
import { IThunkApi } from 'shared/types/redux';
import { IInfrastructureCategory } from 'shared/types/infrastructure';
import { fetchInfrastructure } from 'shared/services/fetchInfrastructure';
import { getInfrastructureRadius } from 'shared/utils/infrastructure';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const getInfrastructureCategories = createAsyncThunk<IInfrastructureCategory[], void, IThunkApiExtended>(
  'infrastructure/getCategories',
  async (_, thunkApi) => {
    const { getState, extra: context, rejectWithValue } = thunkApi;

    const radius = getInfrastructureRadius(context.config);

    const state = getState();

    const houseId = selectHouseId(state);
    const regionId = selectRegionId(state);

    try {
      const response = await fetchInfrastructure(context, {
        parameters: { houseId, radius },
        regionId,
      });

      return response;
    } catch (e) {
      return rejectWithValue();
    }
  },
);
